import { useState } from 'react';
import {
  Video,
  Mic,
  MessageCircle,
  Pill,
  FlaskConical,
  CalendarClock,
  AlertTriangle,
  Camera,
  MicOff,
  ScreenShare,
  FileText,
  XCircle,
} from 'lucide-react';

export default function LiveConsultation() {
  const [mode, setMode] = useState('video');
  const [consent, setConsent] = useState(true);
  const [notes, setNotes] = useState('');
  const [audioOnly, setAudioOnly] = useState(false);

  return (
    <div className="container" style={{ paddingTop: 24, paddingBottom: 24 }}>
      {/* Pre-Join Section */}
      <div className="card card-theme shadow-sm mb-4" style={{ padding: 16, borderRadius: 16 }}>
        <h5 className="fw-semibold mb-2">Hi Simmie, your doctor is ready</h5>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <Camera size={18} className="accent" />
            <span style={{ fontSize: 13 }}>Camera preview</span>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={audioOnly}
              onChange={() => setAudioOnly(!audioOnly)}
            />
            <label className="form-check-label" style={{ fontSize: 13 }}>
              Save Data (Audio Only)
            </label>
          </div>
        </div>
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            checked={consent}
            onChange={() => setConsent(!consent)}
          />
          <label className="form-check-label" style={{ fontSize: 13 }}>
            I consent to recording this session
          </label>
        </div>
      </div>

      {/* Consult Room */}
      <div className="row">
        {/* Main Panel */}
        <div className="col-md-8 mb-4">
          <div className="card card-theme shadow-sm" style={{ padding: 16, borderRadius: 16, minHeight: 320 }}>
            {audioOnly ? (
              <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                <Mic size={32} className="accent me-2" />
                <span style={{ fontSize: 14 }}>Audio-only consultation in progress</span>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                <Video size={32} className="accent me-2" />
                <span style={{ fontSize: 14 }}>Live video with Dr. Sarah Doe</span>
              </div>
            )}
          </div>

          {/* Toolbar */}
          <div className="d-flex gap-3 mt-3 justify-content-center">
            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
              <MicOff size={16} />
            </button>
            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
              <Camera size={16} />
            </button>
            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
              <ScreenShare size={16} />
            </button>
            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
              <FileText size={16} />
            </button>
            <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
              <MessageCircle size={16} />
            </button>
            <button className="btn btn-outline-danger btn-sm" style={{ borderRadius: 8 }}>
              <XCircle size={16} />
            </button>
          </div>
        </div>

        {/* Context Drawer */}
        <div className="col-md-4">
          <div className="card card-theme shadow-sm" style={{ padding: 16, borderRadius: 16 }}>
            <h6 className="fw-semibold mb-2">Patient Summary</h6>
            <ul className="list-unstyled" style={{ fontSize: 13 }}>
              <li><strong>Triage:</strong> Stroke threat</li>
              <li><strong>Allergies:</strong> Penicillin, Peanuts</li>
              <li><strong>Medications:</strong> None reported</li>
              <li><strong>Past Consults:</strong> Malaria (Aug 2025)</li>
            </ul>

            <label className="fw-medium mt-3 mb-1 d-block">Doctor Notes</label>
            <textarea
              className="form-control input-theme"
              rows={3}
              placeholder="Add notes here..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              style={{ fontSize: 13 }}
            />
          </div>

          {/* Doctor Actions */}
          <div className="card card-theme shadow-sm mt-3" style={{ padding: 16, borderRadius: 16 }}>
            <h6 className="fw-semibold mb-2">Doctor Actions</h6>
            <div className="d-flex flex-wrap gap-2">
              <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
                <Pill size={16} className="me-1" /> Prescribe Medication
              </button>
              <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
                <FlaskConical size={16} className="me-1" /> Order Lab Test
              </button>
              <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: 8 }}>
                <CalendarClock size={16} className="me-1" /> Schedule Follow-up
              </button>
              <button className="btn btn-outline-danger btn-sm" style={{ borderRadius: 8 }}>
                <AlertTriangle size={16} className="me-1" /> Emergency Escalation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}